import type { IAppsSdkDescriptionItemDto } from "../types/dto";

export const EMPTY_SDK_DESCRIPTIONS: readonly IAppsSdkDescriptionItemDto[] = [];
